import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getIconClass(icon) {
  if (!icon) return 'fa-regular fa-gears';
  let mapped = icon;
  // Fallback for icons that might not render in certain Font Awesome subsets
  if (icon.includes('fa-garage')) {
    mapped = icon.replace('fa-garage', 'fa-warehouse');
  }
  if (icon === 'fa-regular fa-gate') {
    mapped = 'fa-solid fa-archway';
  }
  if (icon === 'fa-regular fa-shield-security') {
    mapped = 'fa-regular fa-alarm-clock';
  }
  return mapped;
}

export function sortServices(services) {
  if (!Array.isArray(services)) return [];
  const priorityOrder = [
    'portservice-og-lovpligtigt-eftersyn',
    'garageporte',
    'friporte',
    'industriporte',
    'hurtigporte',
    'frostporte-og-frostdoere',
    'garageporte-og-tilbehoer',
    'laager-og-laageautomatik',
    'ramper-og-sluser',
    'alarmsystem',
    'alarmsystem-video-overvaagning',
    'alarmsystem-indbrudssikring',
    'alarmsystem-branddetektion',
    'alarmsystem-forebyggelse-af-vandlaekage',
    'alarmsystem-komfort-og-produktivitet'
  ];

  return [...services].sort((a, b) => {
    const slugA = a.service_slug || a.slug?.da || '';
    const slugB = b.service_slug || b.slug?.da || '';
    
    const indexA = priorityOrder.indexOf(slugA);
    const indexB = priorityOrder.indexOf(slugB);
    
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    return 0;
  });
}
